import { useEffect } from 'react';
import { useTheme } from 'next-themes';
import { useQuery } from 'react-query';
import { getConfig } from '@/services/api/configService';
import { paletteToCssVars, type ThemeModePalette } from '@/utils/themeDerivation';
import { useAuth } from '@/store/authStore';

/**
 * Applicerar dynamiskt tema på hela appen när servern har aktiverat runtime-tema
 * (ENABLE_DYNAMIC_THEME=true eller sparat via Tema & branding). */
export function DynamicThemeApplicator() {
  const { resolvedTheme } = useTheme();
  const { user } = useAuth();
  const { data: config } = useQuery(['config', user?.id ?? 'anon'], getConfig, {
    staleTime: 5 * 60 * 1000,
    retry: 1,
  });

  useEffect(() => {
    if (!config?.dynamicThemeEnabled || !config.theme) return;

    const isDark = resolvedTheme === 'dark';
    const palette: ThemeModePalette = isDark ? config.theme.dark : config.theme.light;
    const vars = paletteToCssVars(palette);

    const root = document.documentElement;
    Object.entries(vars).forEach(([key, value]) => {
      root.style.setProperty(key, value);
    });

    return () => {
      Object.keys(vars).forEach((key) => {
        root.style.removeProperty(key);
      });
    };
  }, [config?.dynamicThemeEnabled, config?.theme, resolvedTheme]);

  return null;
}
